import { Directive, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject, Subject, combineLatest, filter, fromEvent, map, merge, takeUntil } from 'rxjs';

@Directive({
  selector: '[ssResizeBtn]',
})
export class ResizeBtnDirective {

  readonly #destroy = new Subject<void>()

  @Input()
  resizeElement: HTMLElement


  @Output()
  readonly resize = new EventEmitter<{ width: number, height: number }>(null)

  readonly inResizeModeSubject = new BehaviorSubject<boolean>(false);

  get #element() {
    return this._elementRef.nativeElement
  }

  constructor(
    private readonly _elementRef: ElementRef<HTMLElement>
  ) {

  }


  ngAfterViewInit() {


    fromEvent(this.#element, 'mousedown').pipe(
      takeUntil(this.#destroy)
    )
      .subscribe(() => {
        this.inResizeModeSubject.next(true)
      })


    merge(
      fromEvent(window, 'mouseup'),
      fromEvent(window, 'mouseleave')
    )
      .pipe(
        takeUntil(this.#destroy),
        filter(() => this.inResizeModeSubject.value)
      )
      .subscribe(() => {
        this.inResizeModeSubject.next(false)
      })


    combineLatest([this.inResizeModeSubject, fromEvent(window, 'mousemove')])
      .pipe(
        filter(([inResizeMode]) => inResizeMode),
        map(([, ev]) => ev as MouseEvent),
        takeUntil(this.#destroy)
      )
      .subscribe((ev) => {
        const x = ev.clientX;
        const y = ev.clientY;

        const { top, left } = this.resizeElement.getBoundingClientRect()

        const newHeight = y - top;
        const newWidth = x - left;

        this.resizeElement.style.height = newHeight + 'px';
        this.resizeElement.style.width = newWidth + 'px';

        this.resize.emit({ width: newWidth, height: newHeight })
      })
  }



  ngOnDestroy() {
    this.#destroy.next()
    this.#destroy.complete()
  }
}
